import React from 'react';

import styles from './Input.module.scss';
import { inputUtils } from './utils/inputUtils';

export type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  description?: string;
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
  success?: boolean | string;
  warning?: boolean | string;
  error?: boolean | string;
  readOnly?: boolean;
  onReset?: () => void;
  regexp?: RegExp;
};

export const Input = ({
  description,
  prefixIcon,
  suffixIcon,
  success,
  warning,
  error,
  readOnly,
  onReset,
  regexp,
  ...props
}: InputProps) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (newValue && regexp && !regexp.test(newValue)) {
      return;
    }
    props.onChange?.(e);
  };

  const descriptionElement = inputUtils.getDescr({
    success,
    warning,
    error,
    description,
  });

  return (
    <div
      className={styles.input}
      data-test-id="input-container"
      data-disabled={props.disabled}
      data-read-only={readOnly}
      data-has-placeholder={!!props.placeholder}
      data-has-prefix-icon={!!prefixIcon}
      data-success={!!success}
      data-warning={!!warning}
      data-error={!!error}
    >
      <div className={styles.inputContainer}>
        <input
          {...props}
          value={props.value}
          onChange={onChange}
          placeholder={props.placeholder}
        />
        {inputUtils.getIcons({
          success,
          warning,
          error,
          readOnly,
          onReset,
          value: props.value,
          suffixIcon,
          prefixIcon,
          styles,
        })}
        {props.placeholder && (
          <span className={styles.label} data-test-id="input-label">
            {props.placeholder}
          </span>
        )}
      </div>
      {descriptionElement && (
        <span className={styles.description} data-test-id="input-description">
          {descriptionElement}
        </span>
      )}
    </div>
  );
};
